exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main {\n    margin-top: 1em;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main